import { getImageZipUrl } from '@/utils/image';
import { getModelAlias } from '@/utils/modelAliasDisplay';
import { LORA_TYPE_KLEIN_FLUX } from '@/views/model/constants/publish';

export {
  EXPLORE_CKPT_TYPE_TRACKING_MAP,
  mapExploreCkptTypeForTracking,
} from '@/assets/artwork/module/a3/exploreTracking';

// 推荐词
export const recommendationWords = [
  '欧美',
  '国风',
  '二次元',
  'Q版',
];

/**
 * 基础模型类型选项。
 * 展示名走本仓 getModelAlias（Flux→HOLO - A2（原V1）等）。
 * 筛选展示顺序：A3 → A2 → A1 → 其余。
 */
export const ckptTypeOptions = [
  {
    label: getModelAlias('A3'),
    value: 'A3',
    subValue: 'A3',
  },
  {
    label: getModelAlias('Flux'),
    value: 'Flux',
    subValue: 'Flux',
  },
  {
    label: getModelAlias('A1'),
    value: 'A1',
    subValue: 'A1',
  },
  {
    label: getModelAlias('SDXL_1'),
    value: 'SDXL_1',
    subValue: 'SDXL',
  },
  {
    label: getModelAlias('SDXL_2'),
    value: 'SDXL_2',
    subValue: 'SDXL',
  },
  {
    label: getModelAlias('Pony'),
    value: 'Pony',
    subValue: 'Pony',
  },
  {
    label: getModelAlias('Animagine'),
    value: 'Animagine',
    subValue: 'Animagine',
  },
] as const;

export function getCkptTypeSubValue(value: string): string {
  if (!value) return '';
  const [target] = ckptTypeOptions.filter(item => item.value === value);
  return target?.subValue || value;
}

/**
 * 模型广场专属的额外基础模型筛选项。
 * 万能渲染训练的模型 ckptType 为 'Klein'，此项按 ckptType 直接筛选。
 * 单独定义、按需传入 CkptSortFilterBtn，避免污染其他复用该组件的弹窗。
 */
export const modelPlazaExtraCkptTypeOptions = [
  {
    label: '万能渲染模型',
    value: 'Klein',
  },
] as Options<string>;

// 风格类型
export const loraTypeOptions = [
  {
    label: '全部模型',
    value: undefined
  },
  {
    label: '风格模型',
    value: 'LoRA'
  },
  {
    label: '组合风格',
    value: 'Style'
  },
  {
    label: '万能渲染模型',
    value: LORA_TYPE_KLEIN_FLUX
  },
];

export function getLoraTypeLabel(value: string) {
  switch (value) {
    case 'LoRA':
      return '风格模型';
    case 'Style':
      return '组合风格';
    case 'Klein':
    case LORA_TYPE_KLEIN_FLUX:
      return '万能渲染模型';
    case 'Controller':
      return '控制器';
  }
}

export function getCategoryImage(id?: number, width: number = 100) {
  let categoryImage = '';
  switch (id) {
    case 1:
      categoryImage = 'https://pino-img.yingzhongshare.com/2024-05-09/1715235350579-ye3n.png';
      break;
    case 2:
      categoryImage = 'https://pino-img.yingzhongshare.com/style_category_preview/%E5%88%9B%E9%80%A0%E7%B1%BB%E5%9E%8B%E5%9B%BE%E6%A0%8701.png';
      break;
    case 3:
      categoryImage = 'https://pino-img.yingzhongshare.com/style_category_preview/%E5%88%9B%E9%80%A0%E7%B1%BB%E5%9E%8B%E5%9B%BE%E6%A0%8702.png';
      break;
    case 4:
      categoryImage = 'https://pino-img.yingzhongshare.com/style_category_preview/%E5%88%9B%E9%80%A0%E7%B1%BB%E5%9E%8B%E5%9B%BE%E6%A0%8703.png';
      break;
    default:
      categoryImage = 'https://pino-img.yingzhongshare.com/2024-05-20/1716170605159-u4hq.png';
  }

  return getImageZipUrl(categoryImage, { width });
}

/**
 * 发布模型支持的模型类型选项
 */
export const publishLoraTypeOptions = [
  { label: '风格模型', value: 'LoRA' },
  { label: '组合风格', value: 'Style' },
  { label: '万能渲染模型', value: LORA_TYPE_KLEIN_FLUX },
];